export const ALLOWED_UPLOAD_MIME_TYPE = [
    'image/png', // png
    'image/jpeg', // jpg
    'application/pdf', // pdf
    'application/msword', // doc
    'application/vnd.ms-excel', // xls
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // docx
    'application/vnd.oasis.opendocument.text', // odt
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // xlsx
    'application/vnd.oasis.opendocument.spreadsheet', // ods
].join(',');
